export default "__VITE_ASSET__CTS$n0Tk__"